<template>
  <div id="payDraw"></div>
</template>
<script>
var chart;
export default {
  data() {
    return {
      no: true,
      baifenbi: 100,
      myData: [
        [
          "费用类型",
          "保养费用",
          "保险费用",
          "维修费用",
          "其他费用",
          "加油费用",
          "违章费用",
        ],
        //["03-01", 10, 20, 30],
        //["03-02", 0, 0, 0],
        //["03-03", 0, 0, 0],
      ],
    };
  },
  methods: {
    reachData(data) {
      console.log(data);
      this.myData = [
        [
          "费用类型",
          "保养费用",
          "保险费用",
          "维修费用",
          "其他费用",
          "加油费用",
          "违章费用",
          "平均费用",
        ],
      ];
      for (let i = 0; i < data.length; i++) {
        var m = [
          data[i].carNo,
          data[i].careCost,
          data[i].insuCost,
          data[i].repaCost,
          data[i].payCost,
          data[i].refuCost,
          data[i].peccCost,
          data[i].avgCost,
        ];
        this.myData.push(m);
      }
      this.draw();
    },
    draw() {
      this.chart = this.echarts.init(document.getElementById("payDraw"));
      this.option = {
        backgroundColor: "",
        /* title: {
          text: "车辆状况看板"
        }, */
        grid: {
          x: 60,
          y: 40,
          x2: 10,
          y2: 80, //距离下边的距离
        },
        legend: {
          left: 10, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 650, //图行例组件的宽度,默认自适应
          x: "top", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            //color: "#dataModal",
            fontSize: 12,
          },
        },
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return (
              val.seriesName + "（" + val.value[val.seriesIndex + 1] + "元）"
            );
          },
        },
        dataset: {
          source: this.myData,
        },
        xAxis: { type: "category", axisLabel: { rotate: 45 }  },
        yAxis: {},
        series: [
          //系列[
          { type: "bar", color: ["#f83b3b"] },
          { type: "bar", color: ["#3ebaf7"] },
          { type: "bar", color: ["#13ca7f"] },
          { type: "bar", color: ["#e3a726"] },
          { type: "bar", color: ["#6e6e6e"] },
          { type: "bar", color: ["#0bbc28"] },
          { type: "line", color: ["red"] },
        ],
        dataZoom: [
              {
                type: "inside",
                //type: "slider",
                //yAxisIndex:[0],
                //xAxisIndex:[0],
                start: 0, //放大起点
                //end: this.end(list),
                end: 100, //放大终点
                //startValue:10,
                //zoomLock:true
              },
            ]
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    //this.draw();
  },
  destroyed() {},
};
</script>
<style lang="">
#payDraw {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #d4dfe9;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/feiyong/draw.vue